import { defineComponent, openBlock, createElementBlock, normalizeClass, unref } from 'vue';
import { BlankType } from './blank-type.enum.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "blank",
  props: {
    type: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(["iconfont-ssml-editor-public", { "icon-ssml-editor-public-kongliebiao": __props.type === unref(BlankType).LIST }])
      }, null, 2);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=blank.vue.js.map
